import { useQuery } from '@tanstack/react-query';

import { personaApi } from '../api';

import { PERSONAS_QUERY_KEY } from './personasQueryKey';

export const usePersonasQuery = () => {
  return useQuery({
    queryKey: PERSONAS_QUERY_KEY,
    queryFn: () => personaApi.getPersonas(),
  });
};
